export default __webpack_public_path__ + "static/media/fMaltoBuza13.3bad0c83.png";